<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                <e-section 
                    img="vector2.png" 
                    :button1="{text: 'تصفح الدورات', icon: 'mdi-play-box-multiple', to: {name: 'courses'}}"
                    :button2="{text: 'ابدأ دلوقتي', icon: 'mdi-account-plus', to: {name: 'register'}}"
                >
                    <h1 slot="headline" class="font-weight-medium mb-6" style="line-height: 1.2" :style="`font-size: ${pcOnly ? 2.5 : 2.1}rem;`" :class="{'text-center': phoneOnly}">
                        تعليم أفضل ..
                        <br v-if="phoneOnly" />
                         فرص افضل للحياة
                    </h1>
                    <p slot="description" class="mt-0 muted--text" style="line-height: 2rem">
                        التعليم الجيد و المستمر هو مفتاحك لمستقبل أفضل 
                        <br>
                        مكان واحد تقدر تتعلم فيه كل المواد و الكورسات.. ابدأ دلوقتي في دروووسك
                    </p>
                </e-section>

                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />
                        </v-list>

                        <div class="mt-5 d-flex justify-center">
                            <v-btn text :to="{name: 'courses'}">عرض المزيد من الدورات...</v-btn>
                        </div>
                    </v-container>
                </section>


                <e-section 
                    img="vector3.png" 
                    :button2="{text: 'تواصل معنا', icon: 'mdi-message-text-outline', to: {name: 'help'}}"
                    background="rgb(249, 249, 249)"
                >
                    <h1 class="headline mb-4" slot="headline">المعلم الجيد هو عملة نادرة .. يسعي الطلاب للوصول اليها.</h1>
                    <p class="description medium-text muted--text" slot="description">
                        دلوقتي تقدر توصل لطلابك في كل مكان عن طريق دروووسك  و هو منصة تعليمية مصممة خصيصا للمدرسين  <br>
                        هتقدر من خلال منصة دروووسك ترفع محاضراتك و مذكراتك و تسوق كورساتك التعليمية لكل الطلاب و في اي مكان و امكانية الدفع للطلبة بكل الطرق المتاحة
                    </p>
                </e-section>

                <slot name="footer" />
            </div>
        </transition>


        <!-- <app-welcome-dialog v-if="capRunning" v-model="appWelcomeDialog" /> -->
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

// import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        // AppWelcomeDialog,
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            // this.appWelcomeDialog = true;
            this.$router.push({name: 'login'});
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>
